import { NavLink, Outlet } from 'react-router-dom'
import { CHAIN } from '../../config'
import { CommandPalette } from '../CommandPalette'
import { MockBanner } from '../ui/MockBanner'

const NAV_ITEMS = [
  { to: '/', label: 'overview', end: true },
  { to: '/portfolio', label: 'portfolio' },
  { to: '/signals', label: 'signals' },
  { to: '/trades', label: 'trades' },
  { to: '/methodology', label: 'methodology' },
  { to: '/legal', label: 'legal' },
  { to: '/posts', label: 'x posts' },
] as const

export function Shell() {
  return (
    <div className="min-h-screen">
      <MockBanner />
      <header className="border-b border-lime-soft bg-crt-panel">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-6 gap-y-2 px-4 py-3">
          <div className="flex items-baseline gap-3">
            <span className="text-lg tracking-[0.25em] text-crt-lime">
              AGENTIC STONKER
            </span>
            <span className="hidden text-[11px] uppercase tracking-widest text-crt-dim sm:inline">
              autonomous portfolio agent // robinhood chain{' '}
              {CHAIN.mainnet.chainId}
            </span>
          </div>
          <div className="flex items-center gap-3 text-[11px] text-crt-dim">
            <span className="kbd">⌘K</span>
            <span className="hidden sm:inline">command palette</span>
          </div>
        </div>
        <nav className="mx-auto max-w-6xl px-4">
          <ul className="flex flex-wrap gap-1 pb-2">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={'end' in item ? item.end : false}
                  className={({ isActive }) =>
                    `inline-block border px-3 py-1 text-xs uppercase tracking-wider ${
                      isActive
                        ? 'border-lime-strong bg-crt-lime/10 text-crt-lime shadow-glow-sm'
                        : 'border-transparent text-crt-gray hover:border-lime-soft hover:text-crt-lime'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>

      <footer className="mx-auto max-w-6xl border-t border-crt-dim/40 px-4 py-4 text-[11px] text-crt-dim">
        <p>
          Agentic Stonker is an experimental autonomous agent. Nothing on this
          site is investment advice. Tokenized stocks carry issuer and
          smart-contract risk. See{' '}
          <NavLink to="/legal" className="text-crt-gray underline">
            legal
          </NavLink>
          .
        </p>
      </footer>

      <CommandPalette />
    </div>
  )
}
